import Vue from 'vue'
export const NotificationService = {
    dangerType: 'danger',
    vm: new Vue(),
    notifyError(errorMessage) {
        this.vm.$notify({
            message:
            `<b>Error:</b> ${errorMessage}`,
            timeout: 30000,
            icon: 'ni ni-bell-55',
            type: this.dangerType,
        });
    },
    notifyErrorManualClose(errorMessage) {
        if(errorMessage != null && errorMessage != undefined && errorMessage != '') {
            errorMessage = errorMessage.replace(/(?:\r\n|\r|\n)/g, '<br/>');
        }
        this.vm.$notify({
            message:
            `<b>Error:</b> ${errorMessage}`,
            timeout: 30000,
            icon: 'ni ni-bell-55',
            type: this.dangerType,
            closeOnClick: false,
            showClose: true
        });
    },
    notifyInfo(message){
        this.vm.$notify({
            type: 'info',
            message: message,
            timeout: 5000,
            icon: 'ni ni-like-2',
          })
    }
}